import React from "react";
import { Card, Grid, Box, Typography, IconButton, MenuItem, Checkbox } from "@mui/material";
import whiteBackIcon from "../../../icons/whiteBackIcon.svg";
import { useStyles } from "../styles";
import { AppConfigSettingsViewEnum } from "../applicationsConfigSettings";
import { CustomQuestionTypeEnum } from "@inosio/payments-sdk";
import CustomQuestionFields from "./CustomQuestionFields";
import { InputField } from "../../../components/InputController";
import { applicationStyles } from "../../../resui/applications/components/CustomStyles";
import CustomDropdown from "../../../components/customDropdown";

interface PropsType {
  setView: React.Dispatch<React.SetStateAction<AppConfigSettingsViewEnum>>;
}

export default function ApplicationsRentalHistory({ setView }: PropsType) {
  const classes = useStyles();
  const classes1 = applicationStyles();

  const getTypography = (text: string, fontWeight: number, fontSize: string, restProps?: object) => (
    <Typography
      sx={{
        fontFamily: 'Work Sans',
        fontWeight: { fontWeight },
        fontSize: { fontSize },
        lineHeight: '22px',
        ...restProps,
      }}
    >
      {text}
    </Typography>
  )

  return (
    <Grid item xs={12} sx={{ mt: 3.5 }}>
      <Card sx={{ display: "flex", flexDirection: "column", color: "#000" }}>
        <Box className={classes.headerContainer} sx={{ backgroundColor: '#BE6531' }}>
          <IconButton
            sx={{ marginRight: "10px", marginTop: "-4px" }}
            onClick={() => setView(AppConfigSettingsViewEnum.Dashboard)}
          >
            <img src={whiteBackIcon} alt="" height="14px" />
          </IconButton>
          {getTypography('Personal Information', 600, '24px', { color: '#fff' })}
        </Box>

        <Grid container sx={{ p: 2, pt: 2, pb: 1, position: 'relative' }}>
          
          <Box sx={{ width: "100%", p: 2, pb: 4 }}>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={6} lg={4.5} xl={3.5}>
                <Typography sx={{ mb: 2 }} className={classes1.labelText}>
                  Physical Address:
                </Typography>
                <InputField
                  name={"Line1"}
                  label={"Address Line 1"}
                  value={''}
                />
                <InputField
                  name={"Line2"}
                  label={"Address Line 2"}
                  value={''}
                />
                <Grid container direction="row" spacing={1}>
                  <Grid item xs={12} sm={6} id="city-input">
                    <InputField
                      name={"City"}
                      label={"City"}
                      value={''}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} id="state-input">
                    <CustomDropdown
                      label={"State"}
                      isFullWidth
                      value={''}
                      menuProps={{
                        PaperProps: {
                          sx: {
                            borderRadius: '24px',
                          },
                        },
                      }} 
                      handleChange={() => {}}                    >
                      <MenuItem style={{ height: "36px" }} value=''>
                        {`Select state`}
                      </MenuItem>
                    </CustomDropdown>
                  </Grid>
                </Grid>
                <Grid container direction="row" spacing={1}>
                  <Grid item xs={12} sm={6} id="zip-input">
                    <InputField 
                      name={"Zip"} 
                      label={"Zip"} 
                      value={''} 
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} id="countries-dropdown">
                    <CustomDropdown
                      label={"Country"}
                      isFullWidth
                      value={''}
                      menuProps={{
                        PaperProps: {
                          sx: {
                            borderRadius: '24px',
                          },
                        },
                      }} 
                      handleChange={() => {}}                    >
                      <MenuItem style={{ height: "36px" }} value=''>
                        {`Select country`}
                      </MenuItem>
                    </CustomDropdown>
                  </Grid>
                </Grid>

                <Typography sx={{ mb: 2 }} className={classes1.labelText}>
                  Landlord Information:
                </Typography>
                <InputField
                  name={"LandlordName"}
                  label={"Landlord/Property Manger Name"}
                  value={''}
                />
                <InputField
                  name={"LandlordPhone"}
                  label={"Telephone"}
                  value={''}
                />
                <InputField
                  name={"LandlordEmail"}
                  label={"Email Address"}
                  value={''}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={4.5} xl={3.5}>
                <Typography sx={{ mb: 2 }} className={classes1.labelText}>
                  Lease Details:
                </Typography>
                <InputField
                  name={"LandlordMonthlyRentAmount"}
                  label={"Rent Amount"}
                  value={''}
                />
                <InputField
                  name={"MoveInDate"}
                  label={"Move In Date"}
                  value={''}
                />
                <Grid container>
                  <Grid item xs={6}>
                    <InputField
                      name={"MoveOutDate"}
                      label={"Move Out Date"}
                      value={''}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography sx={{ mb: -2 }} className={classes1.bodyText}>
                      <Checkbox 
                        onChange={() => {}}
                        inputProps={{ 'aria-label': 'controlled' }} 
                        sx={{ ml: 1 }}
                      />
                      Current Address
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>

          <CustomQuestionFields CustomQuestionType={CustomQuestionTypeEnum.RentalHistoryV1} />
        </Grid>
      </Card>
    </Grid>
  );
}
